<script setup lang="ts">
import { useUserStore, useSessionStore } from '../../../stores';
import { UserRole } from '../../../types/user';
import StudentLecture from './StudentLecture.vue';
import TeacherLecture from './TeacherLecture.vue';
import Fullscreen from '../../General/Fullscreen.vue';
import Iframe from '../../General/Iframe.vue';
import { Session } from '../../../types/session';

const user = useUserStore()
const sessionStore = useSessionStore()

</script>

<template>
    <template v-if="sessionStore.classContent?.[Session.lecture]?.scormUrl && sessionStore.classContent?.[Session.lecture]?.scormUrl != ''">
        <Fullscreen class="p-3 h-full">
            <Iframe :src="sessionStore.classContent?.[Session.lecture]?.scormUrl" orientation="full"></Iframe>
        </Fullscreen>
    </template>
    <template v-else>
        <StudentLecture v-if="user.userRole === UserRole.student" />
        <TeacherLecture v-if="user.userRole === UserRole.teacher" />
    </template>
</template>